<header class="flex header">
  <h2>Work Order Quantities</h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>

<section class="content">
  <!-- Work Order Info Section -->
  <div class="work-order-info">
    <div class="info-row">
      <span class="label">Work Order:</span>
      <span class="value">{{ workOrder.workOrderNumber }}</span>
    </div>
    <div class="info-row">
      <span class="label">Client:</span>
      <span class="value">{{ workOrder.clientName }} ({{ workOrder.clientCode }})</span>
    </div>
    <div class="info-row">
      <span class="label">Brand:</span>
      <span class="value">{{ workOrder.brandName }} ({{ workOrder.brandCode }})</span>
    </div>
    <div class="info-row">
      <span class="label">Type:</span>
      <span class="value">{{ getWorkOrderTypeLabel(workOrder.workOrderType) }}</span>
    </div>
    <div class="info-row">
      <span class="label">Term:</span>
      <span class="value">{{ getWorkOrderTermLabel(workOrder.workOrderTerm) }}</span>
    </div>
    <div class="info-row">
      <span class="label">Status:</span>
      <span class="value">{{ getWorkOrderStatusLabel(workOrder.status) }}</span>
    </div>
    @if (workOrder.clientProductOrderNumbers.length) {
      <div class="info-row">
        <span class="label">Customer PO:</span>
        <span class="value">{{ workOrder.clientProductOrderNumbers.join(', ') }}</span>
      </div>
    }
  </div>

  <!-- Quantities Table -->
  <div class="quantities-section">
    <h3>Quantity Summary</h3>
    <p-table [value]="quantityRows()" styleClass="p-datatable-sm p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>Stage</th>
          <th class="text-right">Quantity</th>
          <th class="text-right">Rolls</th>
          <th class="text-right">Progress</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [class.highlight-row]="row.label === 'Required Quantity'">
          <td>
            <strong>{{ row.label }}</strong>
          </td>
          <td class="text-right">{{ row.quantity }}</td>
          <td class="text-right">
            @if (row.label !== 'Required Quantity') {
              {{ row.rollsCount }}
            }
          </td>
          <td class="text-right">
            @if (row.label !== 'Required Quantity' && row.percentage !== undefined) {
              <div class="progress-cell">
                <p-progressBar [value]="row.percentage" [showValue]="false" styleClass="progress-bar-small" />
                <span class="percentage-text">{{ row.percentage }}%</span>
              </div>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Missing Quantity Highlight -->
  <div class="missing-quantity-section">
    <div class="missing-box">
      <span class="missing-label">Missing to Dispatch:</span>
      <span class="missing-value">{{ missingQuantity() }}</span>
    </div>
  </div>

  <!-- Production Cards Summary -->
  @if (workOrder.productionCards.length) {
    <div class="production-cards-section">
      <h3>Production Cards ({{ workOrder.productionCards.length }})</h3>
      <p-table [value]="workOrder.productionCards" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th>Card Number</th>
            <th>Color</th>
            <th>Lab Dip</th>
            <th class="text-right">Planned</th>
            <th class="text-right">Actual</th>
            <th>Cycle Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pc>
          <tr>
            <td>
              <a [href]="'/production-card/' + pc.productionCardNumber + '/details'" target="_blank" class="card-link">
                {{ pc.productionCardNumber }}
              </a>
            </td>
            <td>{{ pc.colorName || pc.colorReference }}</td>
            <td>{{ pc.labDipNumber || '—' }}</td>
            <td class="text-right">
              @if (pc.plannedQuantity?.length) {
                {{ pc.plannedQuantity[0].quantity | number: '1.0-2' }} lbs
              } @else {
                —
              }
            </td>
            <td class="text-right">
              @if (pc.actualQuantity?.length) {
                {{ pc.actualQuantity[0].quantity | number: '1.0-2' }} lbs
              } @else {
                —
              }
            </td>
            <td>
              @if (pc.latestCycleStatus) {
                <span class="cycle-badge">{{ pc.latestCycleStatus }}</span>
              }
              @if (pc.latestCycleQCStatus) {
                <span class="qc-badge">{{ pc.latestCycleQCStatus }}</span>
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</section>

<footer>
  <p-button class="w-full" label="Close" variant="outlined" (click)="onClose()" />
</footer>
